module.exports = __webpack_public_path__ + "img/course_0011.8a0f654.webp";